import { jsx as _jsx } from "react/jsx-runtime";
export const CloseIcon = ({ color = 'var(--moveo-accent-color)', size = 24, }) => {
    return (_jsx("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M18 6 6 18M6 6l12 12", stroke: color, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }));
};
